export const disableAutomaticRightIconKey = Symbol('Disable automatic right icon')
